<div class="actions">
	<app-button
		appearance="secondary"
		size="s"
		[isDisabled]="openedDropdown() === dropdownVariantEnum.POSITION_INFO"
		[tuiDropdownMinHeight]="600"
		[tuiDropdownMaxHeight]="600"
		[tuiDropdown]="positionInfoDropdown"
		[tuiDropdownManual]="openedDropdown() === dropdownVariantEnum.POSITION_INFO"
		(clicked)="toggleDropdown(dropdownVariantEnum.POSITION_INFO)"
	>
		{{ 'positions.info' | translate }}
	</app-button>

	<app-button
		appearance="secondary"
		size="s"
		[isDisabled]="openedDropdown() === dropdownVariantEnum.POSITION_CLOSE"
		[tuiDropdownMinHeight]="500"
		[tuiDropdownMaxHeight]="500"
		[tuiDropdown]="positionCloseDropdown"
		[tuiDropdownManual]="openedDropdown() === dropdownVariantEnum.POSITION_CLOSE"
		(clicked)="toggleDropdown(dropdownVariantEnum.POSITION_CLOSE)"
	>
		{{ 'positions.close' | translate }}
	</app-button>

	<app-button
		appearance="secondary"
		size="s"
		[isDisabled]="openedDropdown() === dropdownVariantEnum.POSITION_SLTP"
		[tuiDropdownMinHeight]="600"
		[tuiDropdownMaxHeight]="600"
		[tuiDropdown]="positionSLTPDropdown"
		[tuiDropdownManual]="openedDropdown() === dropdownVariantEnum.POSITION_SLTP"
		(clicked)="toggleDropdown(dropdownVariantEnum.POSITION_SLTP)"
	>
		{{ 'positions.sltp' | translate }}
	</app-button>
</div>

<ng-template #positionInfoDropdown>
	<div
		appClickOutside
		(clickOutside)="onClickOutside()"
	>
		<app-position-info
			[position]="position()"
			(closeDropdown)="toggleDropdown(null)"
		/>
	</div>
</ng-template>

<ng-template #positionCloseDropdown>
	<div
		appClickOutside
		(clickOutside)="onClickOutside()"
	>
		<app-close-position
			[position]="position()"
			(closeDropdown)="toggleDropdown(null)"
		/>
	</div>
</ng-template>

<ng-template #positionSLTPDropdown>
	<div
		appClickOutside
		(clickOutside)="onClickOutside()"
	>
		<app-create-oco-order
			[position]="position()"
			(closeDropdown)="toggleDropdown(null)"
		/>
	</div>
</ng-template>
